export const FILTER_RANGE_KEYS = {
  WIDTH: 'width_product',
  HEIGHT: 'height_product',
  LENGTH: 'length_depth_product',
  DIAMETER: 'product_diameter'
};
